import { render, staticRenderFns } from "./activity-concepts-modal-basic-form.vue?vue&type=template&id=65ae502c&"
import script from "./activity-concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./activity-concepts-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports